var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHomeIndigo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9501 7.50103L11.1001 1.90103C10.4501 1.40103 9.5501 1.40103 8.9001 1.85103L1.1001 7.20103C0.750104 7.45103 0.650104 7.90103 0.900103 8.25103C1.1501 8.60103 1.6001 8.70103 1.9501 8.45103L3.0001 7.70103V13.851C3.0001 16.151 4.8501 18.001 7.1501 18.001H12.8501C15.1501 18.001 17.0001 16.151 17.0001 13.851V7.95103L18.0501 8.70103C18.2001 8.80103 18.3501 8.85103 18.5001 8.85103C18.7501 8.85103 18.9501 8.75103 19.1001 8.55103C19.3501 8.20103 19.2501 7.75103 18.9501 7.50103ZM15.5001 13.851C15.5001 15.301 14.3001 16.501 12.8501 16.501H7.1501C5.7001 16.501 4.5001 15.301 4.5001 13.851V6.65103L9.8001 3.05103C9.9001 2.95103 10.0501 2.95103 10.2001 3.05103L15.5001 6.85103V13.851Z",
    fill: "#1C3D61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeIndigo);
export default __webpack_public_path__ + "static/media/icon-home-indigo.467d720bd77ee6d8442f67addf804afd.svg";
export { ForwardRef as ReactComponent };